import { create } from "zustand";
import { Account } from "~/types/partners";
import { Compensation, Contract } from "~/types/contract";
import { setInitialDate } from "~/utils/date";

const defaultSteps = [
    {
        id: "select-contract",
        title: "Contract selection",
        description:
            "Lorem 1 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
        isCompleted: false,
    },
    {
        id: "claim-details",
        title: "Claim details",
        description:
            "Lorem 2 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
        isCompleted: false,
    },
];

const claimWithCompensationsSteps = [
    {
        id: "select-contract",
        title: "Contract selection",
        description:
            "Lorem 1 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
        isCompleted: false,
    },
    {
        id: "claim-details",
        title: "Claim details",
        description:
            "Lorem 2 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
        isCompleted: false,
    },
    {
        id: "compensation-selection",
        title: "Compensation selection",
        description:
            "Lorem 3 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
        isCompleted: false,
    },
    {
        id: "review-submit",
        title: "Review & submit",
        description:
            "Lorem 3 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
        isCompleted: false,
    },
];

const defaultSelectContract = {} as Contract;

const defaultClaimDetails = {
    periodFrom: setInitialDate() || "",
    periodTo: setInitialDate("plus", { years: 1 }) || "",
    contractPartner: {} as Account,
    file: undefined as any,
    claimCustomerReference: undefined,
    claimCustomerInfo: undefined,
    claimDocumentDate: undefined,
    claimDueDate: undefined,
    paymentType: undefined,
    claimCompensation: undefined,
    sapReleaseDate: undefined,
};

const defaultSelectCompensations: (Compensation & {
    compensationMultiplier?: string;
})[] = [];

interface UploadClaimFileState {
    steps: typeof defaultSteps;
    stepSetter: (steps: any) => void;

    claimCompensationsSteps: typeof claimWithCompensationsSteps;
    stepSetterWithCompensations: (steps: any) => void;

    selectContract: Contract;
    setSelectContract: (contract: any) => void;

    claimDetails: typeof defaultClaimDetails;
    setClaimDetails: (details: any) => void;
    selectCompensations: (Compensation & { compensationMultiplier?: string })[];
    setSelectCompensations: (
        compensations: (Compensation & { compensationMultiplier?: string })[],
    ) => void;
    link:
        | {
              claimHeaderId: string;
              filename: string;
              reason: string;
          }
        | undefined;
    setLink: (link: {
        claimHeaderId: string;
        filename: string;
        reason: string;
    }) => void;
    resetSelectContract: () => void;
    resetUploadClaimData: () => void;
    resetSelectCompensations: () => void;
    preselectContract: (contract: Contract) => void;
}

export const useUploadClaimFileStore = create<UploadClaimFileState>(set => ({
    steps: defaultSteps,
    stepSetter: steps => set({ steps }),

    claimCompensationsSteps: claimWithCompensationsSteps,
    stepSetterWithCompensations: claimCompensationsSteps =>
        set({ claimCompensationsSteps }),

    selectContract: defaultSelectContract,
    setSelectContract: selectContract => set({ selectContract }),

    claimDetails: defaultClaimDetails,
    setClaimDetails: claimDetails => set({ claimDetails }),

    selectCompensations: defaultSelectCompensations,
    setSelectCompensations: selectCompensations => set({ selectCompensations }),
    link: undefined,
    setLink: link => set({ link }),
    resetSelectContract: () =>
        set({ selectContract: { ...defaultSelectContract } }),
    resetSelectCompensations: () =>
        set({ selectCompensations: [...defaultSelectCompensations] }),
    resetUploadClaimData: () =>
        set({
            steps: [...defaultSteps],
            selectContract: { ...defaultSelectContract },
            claimDetails: { ...defaultClaimDetails },
            selectCompensations: [...defaultSelectCompensations],
            link: undefined,
            claimCompensationsSteps: [...claimWithCompensationsSteps],
        }),
    preselectContract: (contract: Contract) => {
        const steps = defaultSteps.map((step, i) =>
            i === 0
                ? { ...step, isPrepared: true, isCompleted: true }
                : { ...step },
        );
        const claimCompensationsSteps = claimWithCompensationsSteps.map(
            (step, i) =>
                i === 0
                    ? { ...step, isPrepared: true, isCompleted: true }
                    : { ...step },
        );
        set({
            steps,
            claimCompensationsSteps,
            selectContract: contract,
            claimDetails: { ...defaultClaimDetails },
            selectCompensations: [...defaultSelectCompensations],
            link: undefined,
        });
    },
}));
